export const animationSettings = {
  logo: {
    'default': ['static'],
    'TEST': ['play', false],

    'STATE:IN:WIN': ['play', false],
  },
}
